import { KText } from '@/ui-library/components/text';
import { Box, Flex } from '@chakra-ui/react';
import { ChevronLeft } from '@kula-ai/icons-core';

export const SecondaryFilter = ({
  filter = {},
  filterActions = () => {},
  activeFilter = {},
  clearSelected = () => {},
  setSelectedFilter = () => {},
}) => {
  const { component, modalActions, list, label } = filter;
  const FilterComponent = component;

  return (
    <Box>
      <Flex mb="12px" gap=".5em" alignItems="center">
        <ChevronLeft
          size="1em"
          color="var(--kula-colors-primary-600)"
          className="kula-icon"
          style={{ cursor: 'pointer' }}
          onClick={() => setSelectedFilter('')}
        />
        <KText size="sm-semi-bold" flex="1" color="secondary-900">
          {label}
        </KText>
      </Flex>
      {component && (
        <FilterComponent
          filterConfig={filter}
          modalActions={modalActions}
          filterActions={filterActions}
          activeFilters={activeFilter}
          onAction={clearSelected}
          list={list || []}
          {...filter}
          type="secondary"
        />
      )}
    </Box>
  );
};
